import React from 'react';

import { useIntl } from 'react-intl';

import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { formatAvatarOptionLabel } from '../../../../../common/ui/filters/select-filter/option-label';
import { useSelectFilter } from '../../../../../controllers/filters';
import { filter as contributorFilter } from '../../../../../controllers/store/search/filters/contributor';

import { i18n } from './messages';

const ContributorFilter = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const [
		filterData,
		{ loadInitialOptions, setLookupInput, setOption, clearLookupInput, clearOptions },
	] = useSelectFilter({
		filterId: contributorFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const {
		isLoading,
		suggestedOptions,
		selectedOptions,
		options,
		isLookupDefined,
		lookupInput,
		isLookupActive,
	} = filterData;

	const groupedOptions = [
		{
			label: formatMessage(i18n.confluenceFilterContributorLabelSelected),
			options: selectedOptions,
		},
		{
			label: formatMessage(i18n.confluenceFilterContributorLabelUnselected),
			options: suggestedOptions,
		},
	];

	return (
		<SelectFilter
			canClearFilter
			checkboxIndicators
			onDropdownOpen={loadInitialOptions}
			onDropdownClose={clearLookupInput}
			onSearchInputChange={setLookupInput}
			onSelectChange={setOption}
			options={isLookupActive ? options : groupedOptions}
			selectedOptions={selectedOptions}
			label={formatMessage(i18n.contributor)}
			placeholder={formatMessage(i18n.confluenceFilterContributorPlaceholder)}
			filterOrControlId={'contributor'}
			isLoading={isLoading}
			isSearchable={isLookupDefined}
			searchInput={lookupInput}
			formatOptionLabel={formatAvatarOptionLabel}
			onClearOptions={clearOptions}
		/>
	);
};

export default ContributorFilter;
